import { render, staticRenderFns } from "./CaseFormRecordType.vue?vue&type=template&id=52a22093&scoped=true&"
import script from "./CaseFormRecordType.vue?vue&type=script&lang=ts&"
export * from "./CaseFormRecordType.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFormRecordType.vue?vue&type=style&index=0&id=52a22093&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a22093",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
